import React from "react";
import CircularProgress from "@mui/material/CircularProgress";

const SpinnerIcon = () => {
  return <CircularProgress />;
};

export default SpinnerIcon;
